export enum ActiveTab {
  PRIVATPERSONEN = 'privatpersonen',
  UNTERNEHMEN = 'unternehmen',
  INSTITUTIONEN = 'institutionen'
}
